<template>
    <div class="pagina-de-entrada">
      <div class="pagina-de-entrada__container pagina-de-entrada__container_primario" tabindex="1">
        <div class="pagina-de-entrada__conteudo-do-container" tabindex="1">
          <img class="logos-do-sistema" src="/Administracao/Content/images/boleto-online/logo-governo.svg" alt=" Agência de Habitação Popular do Estado de Mato Grosso do Sul"/>
          <h3 class="titulo titulo_gigante" tabindex="1">Emissão de boleto online.</h3>
          <p class="texto_medio u-margem-inferior-media" tabindex="1">Emita seu boleto pelo nosso site de forma prática, segura e sem custos. Para acessar, preencha seus dados nos campos ao lado.</p> 
          <p class="texto_medio u-margem-inferior-media" tabindex="1">
            <strong> Serviço de Atendimento ao Público - SAP</strong> <br>
            pelo telefone 0800-647-3120, das 8 às 13 horas.
          </p>
          <p class="texto_medio" tabindex="1">
            <strong>Campo Grande: </strong>Nos postos de atendimento situados nos Fáceis.
          </p>
          <a href="http://www.agehab.ms.gov.br/agehab/atendimento/" target="_blank" tabindex="1" class="botao botao_medio botao_primaria botao_invertido u-margem-superior-media">Encontre um Fácil perto de você</a>
        </div>
        <a href="http://www.digix.com.br/" target="blank" class="pagina-de-entrada__logo-digix" tabindex="3">
          <img src="https://habix.agehab.ms.gov.br/seguranca/Content/imagens/logo-digix-roxo.png" alt="Acesso ao site Digix">
        </a>
      </div>

      <div class="pagina-de-entrada__container pagina-de-entrada__container_secundario" tabindex="2">
        <div class="pagina-de-entrada__conteudo-do-container">
          <div tabindex="2">
            <h2 class="titulo titulo_grande titulo_cor-primaria u-margem-inferior-pequena">Emita seu boleto aqui!</h2>
            <p>Para iniciar, informe os dados abaixo:</p>
          </div>
          <form class="formulario formulario_medio u-margem-inferior-grande" @submit.prevent="efetuarAutenticacao">
              <div class="grade__linha">
                  <label aria-label="Informe o seu CPF no campo abaixo">Seu CPF</label>
                  <input class="formulario__input" 
                    id="cpf" 
                    required="" 
                    v-model="camposParaLogin.cpf" 
                    type="tel" 
                    v-mask="'###.###.###-##'" 
                    aria-label="Insira aqui o número do seu CPF com 11 dígitos" 
                    tabindex="2">
              </div>
              <div class="grade__linha u-margem-superior-pequena">
                  <label aria-label="Informe a sua data de nascimento no campo abaixo">Data de nascimento</label>
                  <input  class="formulario__input" 
                    id="data" 
                    required="" 
                    type="tel" 
                    v-model="camposParaLogin.dataDeNascimento" 
                    placeholder="DD/MM/AAAA" 
                    tabindex="2" 
                    v-mask="'##/##/####'" 
                    aria-label="Informe a sua data de nascimento com 8 dígitos" />
              </div>
              <div class="grade__linha u-margem-superior-pequena">
                  <label aria-label="Informe o número do contrato no campo abaixo">Número de contrato</label>
                  <button class="botao botao_sem-preenchimento botao_mini botao_cor-primaria" type="button" @click="exibirModal">
                      <i class="fa fa-info-circle" aria-hidden="true"></i> Onde encontrar?
                  </button>
                  <input  class="formulario__input" 
                  id="numeroDeContrato" 
                  required=""
                  v-model="camposParaLogin.numeroDeContrato" 
                  tabindex="2" 
                  v-mask="'########'"
                  aria-label="Informe o número do contrato com 8 dígitos" />
              </div>

              <button class="botao botao_grande botao_cor-primaria botao_largura-total u-margem-superior-media" aria-label="Aperte enter para entrar no sistema" type="submit" tabindex="2" >Entrar</button>                          

              <div role="alert" class="mensagem mensagem_cor-erro" v-if="mensagensDeErro.naoPossuiFinanciamento">
                  <i class="far fa-times-circle mensagem__icone"></i>
                  <div class="mensagem__conteudo">
                    <h2 class="mensagem__titulo">Identificamos um erro:</h2>
                    <p class="mensagem__texto">Nenhum financiamento encontrado com estes dados.</p>
                  </div>
              </div>
              <p class="mensagem_aviso-beneficiario mensagem_cor-erro" v-if="mensagensDeErro.financiamentoEstaBloqueado"> Este financiamento encontra-se bloqueado. Por favor, entre em contato com a AGEHAB para maiores informações.</p>
              <modal-informacao-do-numero-de-contrato v-show="deveExibirModal" @fecharModal="fecharModal"></modal-informacao-do-numero-de-contrato>
          </form>
        </div>
      </div>
    </div>
</template>

<script>
  import {mask} from 'vue-the-mask';
  import http from '../../adapters/http';
  import messages from '../../adapters/messages';
  import extensaoDeData from '../../adapters/extensaoDeData'
  import GerenciadorDeTermos from '../../helpers/gerenciadorDeTermos'
  import Cookie from '../../adapters/cookie';
  import BoletoOnline from '../boletoOnline/boletoOnline.vue';
  import ModalInformacaoDoNumeroDeContrato from '../boletoOnline-login/modalDeInformacaoDoNumeroDeContrato.vue'

  export default {
        name: 'login',
        data() {
            return {
                camposParaLogin: {
                  cpf: '',
                  dataDeNascimento: '',
                  numeroDeContrato: '',
                },
                gerenciadorDeTermos: new GerenciadorDeTermos(),
                mensagensDeErro: {
                  naoPossuiFinanciamento: false,
                  financiamentoEstaBloqueado: false,
                },
                deveExibirModal: false
            };
        },
        directives: {
          mask
        },
        components: {
            BoletoOnline,
            'modal-informacao-do-numero-de-contrato': ModalInformacaoDoNumeroDeContrato,
        },
        created() {
            Cookie.remover('cpf');
            Cookie.remover('dataDeNascimento');
            Cookie.remover('numeroDeContrato')
        },
        methods: {
            async efetuarAutenticacao() {
                const camposParaLogin = this.camposParaLogin

                if (!extensaoDeData.dataEhValida(camposParaLogin.dataDeNascimento)) {
                  messages.erro("Data de nascimento inválida para tentar realizar o login.");
                  return;
                }
                
                const usuarioAceitouTermosEmVigor = await this.gerenciadorDeTermos.verificarSeUsuarioAceitouTermosEmVigor(camposParaLogin.cpf)

                if(!usuarioAceitouTermosEmVigor) {
                  this.gerenciadorDeTermos.redirecionarParaOGerenciadorDeTermos(camposParaLogin.cpf)
                  return;
                }

                http.post('/Administracao/boletoOnline/LogIn', camposParaLogin)
                  .then(dados => {
                    this.mensagensDeErro = dados.erros
                      if (!this.existeErroDeLogin()) {
                          const minutosParaExpirar = 30;
                          Cookie.definir('cpf', camposParaLogin.cpf, minutosParaExpirar);
                          Cookie.definir('dataDeNascimento', camposParaLogin.dataDeNascimento, minutosParaExpirar);
                          Cookie.definir('numeroDeContrato', camposParaLogin.numeroDeContrato, minutosParaExpirar);
                          location.href = '/Administracao/boletoOnline/Cobrancas';
                      }
                  })
            },
            existeErroDeLogin() {
              for (let tipoDoErro in this.mensagensDeErro) {
                if (this.mensagensDeErro[tipoDoErro])
                  return true
              }
              return false;
            },

            exibirModal() {
              this.deveExibirModal = true;
            },
            
            fecharModal()
            {
              this.deveExibirModal = false;
            }
        }
    }
</script>
